import { render, staticRenderFns } from "./SalesFlyerNoAds.vue?vue&type=template&id=3179b8b7&scoped=true"
import script from "./SalesFlyerNoAds.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesFlyerNoAds.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SalesFlyerNoAds.vue?vue&type=style&index=0&id=3179b8b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3179b8b7",
  null
  
)

export default component.exports